import { useTranslation } from "react-i18next";
import { useCallback } from "react";

/**
 * Returns a function that prefixes a path with the current language.
 * Usage: const lp = useLangPath(); <Link to={lp("/episodes")} />
 */
export function useLangPath() {
  const { i18n } = useTranslation();
  return useCallback(
    (path: string) => `/${i18n.language}${path}`,
    [i18n.language]
  );
}
